import { render, staticRenderFns } from "./MailListingDraftPage.vue?vue&type=template&id=f5f1ffce&scoped=true&"
import script from "./MailListingDraftPage.vue?vue&type=script&lang=js&"
export * from "./MailListingDraftPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f1ffce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
